/* fantazee — tema betikleri */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Duyuru çubuğu döngüsü */
  $$('[data-announce]').forEach(function (track) {
    var items = $$('.announce__item', track);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4200);
  });

  /* Header gölgesi */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 30); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Arama paneli */
  var searchToggle = $('[data-search-toggle]');
  var searchPanel = $('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.hidden = !searchPanel.hidden;
      if (!searchPanel.hidden) { var inp = $('input[type="search"]', searchPanel); if (inp) inp.focus(); }
    });
  }

  /* Mobil menü */
  var drawer = $('[data-drawer]');
  var openBtn = $('[data-drawer-open]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('no-scroll', open);
  }
  if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
  $$('[data-drawer-close]').forEach(function (el) { el.addEventListener('click', function () { setDrawer(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });

  /* Adet butonları */
  $$('[data-qty]').forEach(function (wrap) {
    var input = $('input', wrap);
    var min = parseInt(input.getAttribute('min') || '1', 10);
    $('[data-qty-minus]', wrap).addEventListener('click', function () { input.value = Math.max(min, (parseInt(input.value, 10) || 0) - 1); });
    $('[data-qty-plus]', wrap).addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 0) + 1; });
  });

  /* Filtre / sıralama otomatik gönderim */
  $$('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form && el.form.submit(); });
  });

  /* Kapanmayan filtre panellerini kapat */
  document.addEventListener('click', function (e) {
    $$('details.filter[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* Para formatı */
  function money(cents) {
    var v = (cents / 100).toFixed(2).split('.');
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '₺' + v[0] + ',' + v[1];
  }

  /* Ürün sayfası: varyant seçimi */
  var productEl = $('[data-product]');
  if (productEl) {
    var json = $('[data-product-json]', productEl);
    var variants = json ? JSON.parse(json.textContent) : [];
    var form = $('#ProductForm');
    var idInput = form && $('[data-variant-id]', form);
    var addBtn = form && $('[data-add-btn]', form);
    var addText = form && $('[data-add-text]', form);
    var priceWrap = $('[data-price-wrap]', productEl);
    var fieldsets = $$('.option', productEl);

    function selected() { return fieldsets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }

    function updateAvailability(sel) {
      fieldsets.forEach(function (fs, idx) {
        $$('.swatch', fs).forEach(function (sw) {
          var val = $('input', sw).value;
          var test = sel.slice(); test[idx] = val;
          var ok = variants.some(function (v) { return v.available && v.options.every(function (o, j) { return o === test[j]; }); });
          sw.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function onChange() {
      var sel = selected();
      fieldsets.forEach(function (fs, idx) { var l = $('[data-option-label]', fs); if (l) l.textContent = sel[idx]; });
      var v = variants.find(function (x) { return x.options.every(function (o, j) { return o === sel[j]; }); });
      updateAvailability(sel);
      if (!v) {
        addBtn.disabled = true; addText.textContent = 'Seçenek mevcut değil';
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addText.textContent = v.available ? 'Sepete Ekle' : 'Tükendi';
      if (priceWrap) {
        var html = '<div class="price' + (v.compare_at_price > v.price ? ' price--sale' : '') + '"><span class="price__current">' + money(v.price) + '</span>';
        if (v.compare_at_price > v.price) {
          html += '<s class="price__compare">' + money(v.compare_at_price) + '</s><span class="price__save">%' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '</span>';
        }
        priceWrap.innerHTML = html + '</div>';
      }
      if (v.featured_media) {
        var slide = $('[data-media-id="' + v.featured_media.id + '"]', productEl);
        var gallery = $('[data-gallery]', productEl);
        if (slide && gallery) {
          if (window.innerWidth < 990) gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
          else if (slide !== gallery.firstElementChild) gallery.insertBefore(slide, gallery.firstElementChild);
        }
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    $$('[data-option]', productEl).forEach(function (r) { r.addEventListener('change', onChange); });
    if (fieldsets.length) updateAvailability(selected());

    /* Beden rehberi butonu */
    $$('[data-open-guide]', productEl).forEach(function (b) {
      b.addEventListener('click', function () { var g = $('#SizeGuide'); if (g) { g.open = true; g.scrollIntoView({ behavior: 'smooth', block: 'center' }); } });
    });

    /* Galeri küçük görselleri */
    var gal = $('[data-gallery]', productEl);
    var thumbs = $$('[data-thumb]', productEl);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var slide = gal.children[parseInt(t.getAttribute('data-thumb'), 10)];
        if (slide) gal.scrollTo({ left: slide.offsetLeft - gal.offsetLeft, behavior: 'smooth' });
      });
    });
    if (gal && thumbs.length) {
      gal.addEventListener('scroll', function () {
        var idx = Math.round(gal.scrollLeft / gal.clientWidth);
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      }, { passive: true });
    }
  }

  /* AJAX sepete ekle */
  function updateCount() {
    fetch(window.Fantazee.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      }).catch(function () {});
  }
  var toastTimer;
  function toast(msg) {
    var t = $('#CartToast'); if (!t) return;
    $('.toast__text', t).textContent = msg;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 4000);
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    var isProduct = f.id === 'ProductForm' || f.classList.contains('js-add-form');
    if (!isProduct || !window.fetch) return;
    if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    e.preventDefault();
    var btn = $('[type="submit"]', f);
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch(window.Fantazee.routes.cart_add_url + '.js', {
      method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f)
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.d.description || 'Ürün eklenemedi'); return; }
        toast('“' + (res.d.product_title || 'Ürün') + '” sepetinize eklendi');
        updateCount();
      })
      .catch(function () { f.submit(); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  /* Önerilen ürünler */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = $('[data-recommendations]', tmp);
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML; else el.remove();
    }).catch(function () {});
  });

  /* Giriş / şifre sıfırla geçişi */
  var loginBox = $('#LoginBox'), recoverBox = $('#RecoverBox');
  if (loginBox && recoverBox) {
    var showRecover = function (on) { loginBox.hidden = on; recoverBox.hidden = !on; };
    $$('[data-toggle-recover]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); showRecover(a.getAttribute('href') === '#recover'); });
    });
    if (window.location.hash === '#recover') showRecover(true);
  }

  /* Adres silme onayı ve ülke seçimi */
  $$('form[data-confirm]').forEach(function (f) {
    f.addEventListener('submit', function (e) { if (!window.confirm(f.getAttribute('data-confirm'))) e.preventDefault(); });
  });
  $$('select[data-default]').forEach(function (s) { var d = s.getAttribute('data-default'); if (d) s.value = d; });

  /* Sepet: sözleşme onayı zorunlu */
  var termsBox = $('[data-terms-box]');
  if (termsBox) {
    var cartForm = termsBox.form;
    var err = $('[data-terms-err]');
    var block = function (e) {
      if (termsBox.checked) return;
      e.preventDefault();
      e.stopPropagation();
      if (err) err.hidden = false;
      $('[data-terms]').classList.add('is-error');
      termsBox.focus();
    };
    if (cartForm) cartForm.addEventListener('submit', function (e) {
      var sub = e.submitter;
      if (sub && sub.name === 'checkout') block(e);
    });
    var extra = $('.cart__extra');
    if (extra) extra.addEventListener('click', block, true);
    termsBox.addEventListener('change', function () { if (termsBox.checked) { if (err) err.hidden = true; $('[data-terms]').classList.remove('is-error'); } });
  }

  /* Bağlantıyı kopyala */
  $$('[data-copy-link]').forEach(function (b) {
    b.addEventListener('click', function () {
      var url = b.getAttribute('data-copy-link');
      var done = function () { var c = $('[data-copied]', b.parentNode); if (c) { c.hidden = false; setTimeout(function () { c.hidden = true; }, 2000); } };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
    });
  });

  /* 18+ yaş doğrulama */
  var gate = $('#AgeGate');
  function showCookieBar() {
    var bar = $('#CookieBar');
    if (!bar) return;
    try { if (localStorage.getItem('fz_cookie')) return; } catch (e) {}
    bar.hidden = false;
  }
  if (gate && !document.documentElement.classList.contains('age-ok')) {
    var yes = $('[data-age-yes]', gate);
    if (yes) setTimeout(function () { yes.focus(); }, 60);
    yes && yes.addEventListener('click', function () {
      var days = parseInt(gate.getAttribute('data-days'), 10) || 30;
      try { localStorage.setItem('fz_age_ok', String(Date.now() + days * 864e5)); } catch (e) {}
      gate.classList.add('is-leaving');
      setTimeout(function () { document.documentElement.classList.add('age-ok'); gate.classList.remove('is-leaving'); showCookieBar(); }, 450);
    });
    var no = $('[data-age-no]', gate);
    no && no.addEventListener('click', function () {
      $('[data-agegate-ask]', gate).hidden = true;
      $('[data-agegate-denied]', gate).hidden = false;
      setTimeout(function () { window.location.href = gate.getAttribute('data-redirect') || 'https://www.google.com'; }, 2200);
    });
  } else {
    showCookieBar();
  }
  $$('[data-cookie-accept]').forEach(function (b) {
    b.addEventListener('click', function () {
      try { localStorage.setItem('fz_cookie', b.getAttribute('data-cookie-accept') || 'all'); } catch (e) {}
      var bar = $('#CookieBar'); if (bar) bar.hidden = true;
    });
  });

  /* Görünür oldukça yumuşak giriş */
  if ('IntersectionObserver' in window) {
    var targets = $$('.section-head, .tile, .card, .quote, .split__inner > *, .bigsize__inner > *, .usp__item, .contact-card');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (t, i) {
      if (t.getBoundingClientRect().top > window.innerHeight) {
        t.classList.add('reveal');
        t.style.transitionDelay = ((i % 4) * 80) + 'ms';
        io.observe(t);
      }
    });
  }
})();
